export default __webpack_public_path__ + "static/media/KZ.T.13.2501 black.3c4c5b41.svg";